import { SVGProps } from 'react';

const ThumbScaleMediumKindDownDownReducedTrue = (props: SVGProps<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <path
            d="M19.4109 5V12.7M5.99998 7H3.92691C2.86404 7 1.96015 7.75623 1.79853 8.78068L1.0255 13.6807C0.824817 14.9528 1.83409 16.1 3.15389 16.1H5.66849C6.06492 16.1 6.3863 16.4134 6.3863 16.8V19.2739C6.3863 20.2272 7.17875 21 8.1563 21C8.38946 21 8.60075 20.8661 8.69545 20.6583L9.95847 17.887M23 11.3V6.4C23 5.6268 22.3572 5 21.5644 5H11.9269C10.864 5 9.96012 5.75623 9.79851 6.78068L9.02548 11.6807C8.8248 12.9528 9.83406 14.1 11.1539 14.1H13.6685C14.0649 14.1 14.3863 14.4134 14.3863 14.8V17.2739C14.3863 18.2272 15.1787 19 16.1563 19C16.3894 19 16.6007 18.8661 16.6954 18.6583L19.2215 13.1157C19.3367 12.8629 19.5938 12.7 19.8774 12.7H21.5644C22.3572 12.7 23 12.0732 23 11.3Z"
            stroke="var(--bloko-icon-color, var(--bloko-icon-color-default))"
            strokeWidth={2}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);
export default ThumbScaleMediumKindDownDownReducedTrue;
